<script>
  export let abbr, gender;

  import * as typologies from "../configs/typologies.json";
  import * as conversions from "../configs/conversions.json";

  $: archetype = typologies.default[abbr][gender];

  //import {convertAbbreviated,fullstopize} from "../global";

  import Initialism from "./Initialism.svelte";

  const FORMAT = "png";
</script>

<div
  on:click
  class="card"
  style="background-color:{archetype.color};box-shadow:inset 0 0 0 1px {archetype.spotlightColor},0 0 1rem 0 {archetype.spotlightColor};background-image:radial-gradient(ellipse 100% 25% at bottom, {archetype.spotlightColor}, black);"
>
  <img
    src="/pictures/archetypes/{gender}/{archetype.name}.{FORMAT}"
    class="card-img-top"
    alt={archetype.name}
  />
  <div class="card-footer">
    <h3>
      <strong class="text-overlap sw"
        ><Initialism
          initials={abbr}
          dictWhatEveryLetterStandsFor={conversions}
        /></strong
      >
    </h3>
    <h2><strong>{archetype.name}</strong></h2>
  </div>
</div>

<style>
  .card {
    width: 10rem;
    max-width: calc(50vw - 2rem - 1px);
    display: inline-block;
    vertical-align: top;
    margin: 0.5rem;
    color: white;
    background-blend-mode: color-dodge;
    /*filter: contrast(0.5) hue-rotate(-60deg) saturate(1.25) contrast(1.8) hue-rotate(-300deg) brightness(1.1);*/
    transition:
      filter 0.125s ease-in-out,
      transform 0.25s ease-in-out;
    cursor: pointer;
    position: relative;
  }
  .card:hover {
    filter: contrast(0.75) saturate(1.5) brightness(1.25);
    transform: scale(1.25);
    z-index: 2;
  }
  .card-footer {
    perspective: 5rem;
    /*overflow: hidden;*/
    padding-left: 0;
    padding-right: 0;
  }
  .card-footer h2,
  .text-overlap {
    letter-spacing: -1px;
  }
  .card-footer h2 {
    text-transform: uppercase !important;
    white-space: nowrap;
    text-shadow:
      0 -1px 1px black,
      0 1px 1rem black;
    transform: rotateX(15deg);
  }
  .card-img-top {
    object-fit: cover;
    object-position: center top;
    height: 10rem;
    min-height: 10rem;
    max-height: 10rem;
    /*border-top-right-radius: 50%;*/
    border-bottom-left-radius: 33.3333333333%;
    border-bottom-right-radius: 0.5rem;
    transform: scale(0.95);
    border: 1px solid #ffffff80;
  }
  .text-overlap {
    position: absolute;
    z-index: 2;
  }
  .text-overlap.sw {
    bottom: 2.5rem;
    left: 0.5rem;
    text-shadow:
      0.05rem -0.05rem black,
      0.1rem -0.1rem black,
      0.1rem -0.1rem 0.25rem black,
      0.05rem -0.05rem 0.25rem black,
      0 0 0.25rem black;
  }
</style>
